import { render, staticRenderFns } from "./EditApplicationTemplate.vue?vue&type=template&id=98c7a13a&scoped=true"
import script from "./EditApplicationTemplate.vue?vue&type=script&lang=ts"
export * from "./EditApplicationTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c7a13a",
  null
  
)

export default component.exports